module.exports = __webpack_public_path__ + "img/B4-20190410_01.22ad290a.jpg";